import { SCHEMA, DOMAIN, REACT_APP_IS_WEB, REACT_APP_FIREBASE_PASSWORD } from 'react-native-dotenv';
import { storageHelper, navigationHelper, alertHelper, firebaseConfig as FC } from '../../config';
const apiRoot = process.env.REACT_APP_API_ROOT ? process.env.REACT_APP_API_ROOT : `${SCHEMA}://api.${DOMAIN}`;
const rootUrl = process.env.REACT_APP_HOSTNAME ? process.env.REACT_APP_HOSTNAME : `${SCHEMA}://${DOMAIN}`;
const uploadRoot = process.env.REACT_APP_STORAGE ? process.env.REACT_APP_STORAGE : `${SCHEMA}://uploads.${DOMAIN}`;
const isWeb = process.env.REACT_APP_IS_WEB ? process.env.REACT_APP_IS_WEB : REACT_APP_IS_WEB;
const firebasePassword = process.env.REACT_APP_FIREBASE_PASSWORD ? process.env.REACT_APP_FIREBASE_PASSWORD : REACT_APP_FIREBASE_PASSWORD;


const siteTitle = () => {
    return 'Gamings Finest';
};

const parseItem = (key) => {
    let auth = storageHelper.getItem(key);
    return auth ? auth : null;
};

const identity = parseItem('authentication');
const token = parseItem('token');
const authToken = () => {
    return (token) ? token : null;
};

const authHeader = () => {
    const headers = (token) ? ({ 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }) : ({ 'Content-Type': 'application/json' });
    return headers;
};

const logout = () => {
    // remove user from local storage to log user out
    storageHelper.removeItem('authentication');
    storageHelper.removeItem('token');
    setTimeout(function(){ navigation('logout'); }, 900);
    firebaseLogout();
    fbLogout();
};
const fbLogout = () =>{

}

const clearAll = () => {
    logout();
}

const storeItem = (key, data) => {
    // remove user from local storage to log user out
    storageHelper.setItem(key, data);
};

const firebase = FC;
const db = FC.db;
const storage = FC.storage;
const app = FC.app;
const auth = app.auth();
const ref = db.ref();

const sendToFirebase = async (ref, data) => {
    return await db.ref(ref).set(data);
};

const isNotified = (recipients) => {
    recipients && recipients.map(async (recipient_id) => {
        await db.ref(`User/${recipient_id}`).update({ 'is_notified': Date.now() });
    });
    return true;
};

const firebaseRegister = (username) => {
    const authentication = parseItem('authentication');
    const user = authentication && authentication.user;
    const auth = app.auth();
    return auth
        .createUserWithEmailAndPassword(username, firebasePassword)
        .then((authUser) => {
            sendToFirebase(`/User/${user.id}`, user);
        }).catch(function (error) {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log("Register Error:", errorCode, errorMessage);
        });
};

const firebaseLogin = async (username) => {
    const authentication = await parseItem('authentication');
    const user = authentication && authentication.user;
    const auth = app.auth();
   // console.log(username , " === " ,firebasePassword);
    return await auth.signInWithEmailAndPassword(username, firebasePassword)
        .then((auth) => {
            sendToFirebase(`/User/${user.id}`, user);
            return auth;
        })
        .catch(async (error) => {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log(errorCode, errorMessage);
            if (errorCode === 'auth/user-not-found') {
                return await firebaseRegister(username);
            }
        });
};



const firebaseUpdatePassword = (newPassword) => {
    const user = app.auth().currentUser;
    user.updatePassword(newPassword).then(function () {
        // Update successful.
    }).catch(function (error) {
        // An error happened.
    });
};

const firebaseLogout = () => {
    const auth = app.auth();
    return auth
        .signOut();
};

const messageToFirebase = async (data, key = null) => {
    const { message, recipients } = data;
    let messageKey = (key === null) ? db.ref('/UserMessage').push().key : key;
    recipients.key = messageKey;
    await sendToFirebase(`/UserMessage/${messageKey}/${message.created_at}`, message);
    await sendToFirebase(`/UserMessageRecipient/${messageKey}`, recipients);

   /* if (group !== null) {
        group.key = messageKey;
        await sendToFirebase(`/UserMessageGroup/${messageKey}`, group);
    }
    if (item !== null) {
        item.key = messageKey;
        await sendToFirebase(`/UserMessageItem/${messageKey}`, item);
    }*/

    return messageKey;
};

const deleteFirebaseMessage = async (messageKey) => {
    if (messageKey === null || messageKey === undefined || messageKey === '') return false;
    await db.ref(`/UserMessage/${messageKey}`).remove();
    await db.ref(`/UserMessageRecipient/${messageKey}`).remove();
    await db.ref(`/UserMessageGroup/${messageKey}`).remove();
    await db.ref(`/UserMessageItem/${messageKey}`).remove();
}
const readMessageThread = (messageKey, user_id) => {
    let update = {};
    let data = { id: user_id, unread: 0, status: 'read' };
    update[`/UserMessageRecipient/${messageKey}/recipients/${user_id}`] = data;
    db.ref().update(update);
    /*db.ref(`/UserMessageRecipient/${messageKey}/recipients/${user_id}`)
        .once("value", function (snap) {
            snap.ref.update({ id: user_id, unread: 0, status: 'read' });
    });*/
}

const readMessage = (messageKey, createdAt, user_id) => {
    let update = {};
    update[`/UserMessage/${messageKey}/${createdAt}/recipients/${user_id}`] = { id: user_id, status: 'read' };
    db.ref().update(update);
}

const ObjectToArray = (objs) => {
    const items = [];
    objs && Object.keys(objs).map(itemKey => {
        const item = objs[itemKey];
        items.push(item);
    });
    return items;
};

const ObjectToArray2 = (objs) => {
    const items = [];
    objs && Object.keys(objs).map((itemKey) => {
        const item = objs[itemKey];
        items.push({ item: item, key: itemKey });
    });
    return items;
};

const getUser = () => {
    return (identity && identity.user) ? identity.user : null;
};

const isOwner = (user_id) => {
    const user = getUser();
    return (user && user.id === user_id);
};

const clearErrorMessages = () => {
    this.errors = [];
};

const handleHttpError = (error) => {
    throw new Error(error || 'Server Error');
};

const handleErrors = (error) => {
    const httpErrorCode = error.status;
    this.clearErrorMessages();
    switch (httpErrorCode) {
        case 401:
            const msg = error.error.data.message;
            this.errors.push(msg);
            this.error(msg, { showProgressBar: false });
            break;
        case 403:
            this.router.navigateByUrl('/');
            break;
        case 422:
            const messages = error.error.data.validation_messages;
            for (const message in messages) {
                if (messages[message]) {
                    this.errors.push(messages[message].join(''));
                }
            }
            this.warning(messages, { showProgressBar: false });
            break;
        default:
            this.error('An error occurred while processing your request.', { showProgressBar: false });
    }
};

const showErrors = (dispatch, exception, alertSelectors) => {
    if (exception instanceof TypeError) {
        dispatch(alertSelectors.error(`${exception.name}: ${exception.message}`))
    } else {
        if (exception instanceof String) {
            dispatch(alertSelectors.error(exception))
        } else {
            let demo = exception instanceof String
            console.log('exception', demo)
            //if(demo === false) return true;
            exception && exception && exception.text().then(message => {
                const errorMessage = JSON.parse(message);
                if(errorMessage.status === 401) {
                    console.log('exception', errorMessage.message);
                    logout();
                }
                (errorMessage !== undefined) && (errorMessage.errors !== undefined) && (errorMessage.errors.length > 0) && errorMessage.errors.map(item => dispatch(alertSelectors.error(item)));
            });
           // console.log('exception', exception);
        }

    }
};

const IsJson = (str) => {
    try {
       JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};

const requestOptions = (method = "GET", params = null) => {
    let headers = authHeader();
    let body = (params === null) ? null : JSON.stringify(params);
    return { method, headers, body };
};

const requestParamsQuery = (params) => {
    const query = Object.keys(params).map(k => {
        let key = encodeURIComponent(k);
        let inValid = ((params[key] === '') || (params[key] === undefined) || (params[key] === null));
        let val = (inValid ? null : encodeURIComponent(params[k]));
        return (inValid ? null : `${key}=${val}`);
    }).filter(item => (item !== null)).join('&');
    return query;
};

const requestParams = (url, params) => {
    const query = requestParamsQuery(params);
    return (params === null) ? url : (url + '?' + query);
};

const request = (url, options) => {
    return fetch(url, options)
        .then(
            response => {
                if (!response.ok) {
                    throw response
                }
                return response.json();
            });
};

const httpURL = (url) => {
    return (isWeb === true) ? (new URL(url)) : url;
};

const navigation = (location, is_reload = false, params=null) => {
    let query = (params !== null) ? requestParamsQuery(params) : null;
    switch (location) {
        case 'welcome':
            navigationHelper.welcome(is_reload);
            break;
        case 'services':
            navigationHelper.service(is_reload);
            break;
        case 'home':
            navigationHelper.home(is_reload);
            break;
        case 'login':
            navigationHelper.login();
            break;
        case 'logout':
            navigationHelper.logout();
            break;
        case 'received':
            navigationHelper.receivedOffer();
            break;
        case 'offers-sent-services-exchange':
        case 'offers-sent-services-cash':
        case 'offers-received-services-exchange':
        case 'offers-received-services-cash':
            navigationHelper.offersLocation(location.split('-').join('/'));
            break;
        case 'service-search':
            navigationHelper.serviceSearch(is_reload);
            break;
        case 'message':
            navigationHelper.message(is_reload, query);
            break;
        default:
    }

};

const messageAlert = (message) => {
    alertHelper.confirm(message);

};

const truncateString = (string, length) => {
    return string.length > length ? string.substring(0, length) + '...' : string;
};
const truncateWord = (string, length) => {
    return string.split(" ").splice(0, length).join(" ");
};

const html2text = (html) => {
    const text = (html !== null) ? html.replace(/<\/?[^>]+>/ig, " ") : '';
    return text;
};
const capitalize = (s) => {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1)
};

const checkImage = (uri) => {
    if (uri === undefined || uri === null) return false;
    return (uri.match(/(jpeg|jpg|gif|png)$/) != null);
};

const fileExtension = (url) => {
    if (url === undefined) return false;
    let extension = url.split('.').pop().split()[0];
    return extension;
}

const classIcon = (extension) => {
    let icons = null
    if (extension === false) return 'file';
    switch (true) {
        case (extension.match(/(xls|xlsx|ods|xlr|csv|xlt|xlm|xlsm|xltx|xltm|xlsb|xla|xlam|xll|xlw)$/) != null):
            icons = 'excel';
            break;
        case (extension.match(/(odp|pps|ppt|pptx|pps|pot)$/) != null):
            icons = 'powerpoint';
            break;
        case (extension.match(/(doc|docx|odt|rtf|tex|wks|wpd|dot|wbk|docm|dotx|dotm|docb)$/) != null):
            icons = 'word';
            break;
        case (extension.match(/(pdf|txt|)$/) != null):
            icons = 'pdf';
            break;
        default:
            icons = 'file';
    }
    return icons
}


const listToTree = (data, options) => {
    options = options || {};
    var ID_KEY = options.idKey || 'id';
    var PARENT_KEY = options.parentKey || 'parent';
    var CHILDREN_KEY = options.childrenKey || 'children';
    var tree = [],
      childrenOf = {};
    var item, id, parentId;
    for (var i = 0, length = data.length; i < length; i++) {
      item = data[i];
      id = item[ID_KEY];
      parentId = item[PARENT_KEY] || 0;
      // every item may have children
      childrenOf[id] = childrenOf[id] || [];
      // init its children
      item[CHILDREN_KEY] = childrenOf[id];
      if (parentId !== 0) {
        // init its parent's children object
        childrenOf[parentId] = childrenOf[parentId] || [];
        // push it into its parent's children object
        childrenOf[parentId].push(item);
      } else {
        tree.push(item);
      }
    };
    return tree;

    /** Examples
     * var tree = gs.listToTree(result, {
        idKey: 'id',
        parentKey: 'parent_id',
        childrenKey: 'children'
    });
     */
}

const convertTimestamptoTime = (unixTimestamp) => {
    // and then create a new Date object
    const dateObj = new Date(unixTimestamp * 1000);

    // Get hours from the timestamp
    const hours = dateObj.getUTCHours();

    // Get minutes part from the timestamp
    const minutes = dateObj.getUTCMinutes();

    // Get seconds part from the timestamp
    //const seconds = dateObj.getUTCSeconds();

    const formattedTime = hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');  //+ ':' +  seconds.toString().padStart(2, '0')
    return formattedTime;
}

const platformIcon = (icon) => {
    let newIcon = '';
    switch (icon) {
        case 'mobile':
            newIcon = '/images/smartphone.svg';
            break;
        case 'console':
            newIcon = '/images/gamepad.svg';
            break;
        case 'computer':
            newIcon = '/images/Mause.svg';
            break;
        default:
    }
    return newIcon;
}

const reward = (reward) => {
    let text = '';
    switch (reward) {
        case 'winner':
            text = '1st Place';
            break;
        case 'runner':
            text = '2nd Place';
            break;
        default:
            text = reward;
            break;
    }
    return text;
}

const trophy = (reward, leagues = 'double-elimination') => {
    let text = '';
    switch (reward) {
        case 'gold':
            text = '1st Place';
            break;
        case 'silver':
            text = '2nd Place';
            break;
        case 'Bronze':
        case 'bronze':
            text = `${ (leagues === 'double-elimination') ? ' 3rd Place' : '3rd and 4th'}`;
            break;
        default:
            text = reward;
            break;
    }
    return text;
}

const winnerTrophy = (reward) => {
    let text = '';
    switch (reward) {
        case 'winner':
            text = '1st Place';
            break;
        case 'runner':
            text = '2nd Place';
            break;
        case 'Bronze':
            text = '3rd and 4th';
            break;
        default:
            text = reward;
            break;
    }
    return text;
}

const countryToFlag = (code) => {
    let isoCode = (code === null || code === undefined) ? 'us' : code;
    return isoCode.toUpperCase().replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397));
}

export const globalService = {
    identity,
    getUser,
    rootUrl,
    isOwner,
    clearErrorMessages,
    siteTitle,
    handleHttpError,
    handleErrors,
    request,
    requestOptions,
    requestParamsQuery,
    requestParams,
    apiRoot,
    uploadRoot,
    authHeader,
    authToken,
    showErrors,
    logout,
    storeItem,
    parseItem,
    httpURL,
    navigation,
    IsJson,
    sendToFirebase,
    messageToFirebase,
    deleteFirebaseMessage,
    readMessageThread,
    readMessage,
    firebase,
    ObjectToArray,
    ObjectToArray2,
    truncateString,

    messageAlert,
    truncateWord,
    app,
    storage,
    db,
    ref,
    auth,

    html2text,
    firebaseRegister,
    firebaseLogin,
    firebaseUpdatePassword,
    firebaseLogout,
    isNotified,
    capitalize,
    checkImage,
    fileExtension,
    classIcon,
    clearAll,
    listToTree,
    convertTimestamptoTime,
    platformIcon,
    reward,
    countryToFlag,
    trophy,
    winnerTrophy
};
